/**
 * Benefit Type Constant
 */

export default {
  CREDIT: 'CREDIT',
  PRICE: 'PRICE',
  SERVICE: 'SERVICE'
};
